var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", { staticClass: "pega-break" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "boss-layout-block" }, [
      _c("div", { staticClass: "boss-table-wrap" }, [
        _c(
          "table",
          {
            staticClass:
              "boss-table-4 boss-table-4-responsive pega-th-color-important pega-print-resume-table",
          },
          [
            _c("tr", [
              _c("th", [_vm._v("セミナー")]),
              _vm._v(" "),
              _c(
                "td",
                { attrs: { colspan: "4", "data-test": "seminar-name" } },
                [_vm._v(_vm._s(_vm.resume.seminarName))]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticClass:
                    "boss-table-4-plain boss-resume-sheet-photo-space-cell padding-bottom-1",
                  attrs: { rowspan: "6" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "boss-resume-sheet-photo-space-layout" },
                    [
                      _vm._m(1),
                      _vm._v(" "),
                      _c("div", { attrs: { "data-test": "user-id" } }, [
                        _vm._v("会員ID：" + _vm._s(_vm.resume.userId)),
                      ]),
                    ]
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v("セミナー日時")]),
              _vm._v(" "),
              _c(
                "td",
                { attrs: { colspan: "4", "data-test": "seminar-date-time" } },
                [
                  _vm._v(
                    _vm._s(_vm._f("formatDate")(_vm.resume.seminarDate)) +
                      " " +
                      _vm._s(_vm.resume.seminarTime)
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _vm._m(2),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v("フリガナ")]),
              _vm._v(" "),
              _c("td", { attrs: { colspan: "4", "data-test": "name-kana" } }, [
                _vm._v(_vm._s(_vm.userNameKana)),
              ]),
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v("氏名")]),
              _vm._v(" "),
              _c("td", { attrs: { colspan: "4", "data-test": "name" } }, [
                _vm._v(_vm._s(_vm.userName)),
              ]),
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v("生年月日")]),
              _vm._v(" "),
              _c("td", { attrs: { colspan: "2", "data-test": "birthday" } }, [
                _vm._v(
                  _vm._s(_vm._f("formatDate")(_vm.resume.birthday)) +
                    " " +
                    _vm._s(_vm.ageLabel)
                ),
              ]),
              _vm._v(" "),
              _c("th", [_vm._v("性別")]),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticClass: "text-nowrap",
                  attrs: { "data-test": "gender" },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm._f("parseBlankForDefaultValue")(_vm.resume.gender)
                    )
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", { attrs: { rowspan: "2" } }, [_vm._v("現住所")]),
              _vm._v(" "),
              _c("td", { attrs: { colspan: "5", "data-test": "zip" } }, [
                _vm._v(_vm._s(_vm.formatZip)),
              ]),
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { attrs: { colspan: "5", "data-test": "address" } }, [
                _vm._v(_vm._s(_vm.resume.address)),
              ]),
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v("電話番号")]),
              _vm._v(" "),
              _c("td", { attrs: { "data-test": "tel", colspan: "2" } }, [
                _vm._v(
                  _vm._s(_vm._f("parseBlankForDefaultValue")(_vm.resume.tel))
                ),
              ]),
              _vm._v(" "),
              _c("th", [_vm._v("携帯電話番号")]),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticClass: "text-nowrap",
                  attrs: { colspan: "2", "data-test": "mobile" },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm._f("parseBlankForDefaultValue")(_vm.resume.mobile)
                    )
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v("メールアドレス")]),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticClass: "pega-break",
                  attrs: { colspan: "2", "data-test": "email" },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm._f("parseBlankForDefaultValue")(_vm.resume.email)
                    )
                  ),
                ]
              ),
              _vm._v(" "),
              _c("th", [_vm._v("携帯メールアドレス")]),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticClass: "pega-break",
                  attrs: { colspan: "2", "data-test": "email-mobile" },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm._f("parseBlankForDefaultValue")(
                        _vm.resume.emailMobile
                      )
                    )
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _vm._m(3),
            _vm._v(" "),
            _vm._m(4),
            _vm._v(" "),
            _c("tr", [
              _c(
                "td",
                { attrs: { colspan: "6", "data-test": "graduated-school" } },
                [
                  _vm._v(
                    _vm._s(_vm.resume.graduatedSchool) +
                      " " +
                      _vm._s(_vm.resume.educationDepartment) +
                      " " +
                      _vm._s(_vm.graduateLabel) +
                      " (最終学歴:" +
                      _vm._s(
                        _vm._f("parseBlankForDefaultValue")(
                          _vm.resume.lastEducationalBackground
                        )
                      ) +
                      ")\n            "
                  ),
                  _c(
                    "div",
                    {
                      attrs: {
                        "data-test": "graduated-school-department-category",
                      },
                    },
                    [
                      _vm._v(
                        "\n              学部・学科コード: " +
                          _vm._s(
                            _vm._f("parseBlankForDefaultValue")(
                              _vm.resume.educationDepartmentCategory
                            )
                          ) +
                          "\n            "
                      ),
                    ]
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _vm._m(5),
            _vm._v(" "),
            _c("tr", [
              _c(
                "td",
                { attrs: { colspan: "6", "data-test": "experience-company" } },
                [
                  _vm._v(
                    _vm._s(_vm.resume.recentExperienceCompanyName) +
                      " " +
                      _vm._s(
                        _vm.resume.recentExperienceCompanyEmploymentStatusName
                      ) +
                      "\n            "
                  ),
                  _c(
                    "div",
                    { attrs: { "data-test": "experience-company-business" } },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.resume
                              .recentExperienceCompanyBusinessCategoryName
                          ) +
                          "\n            "
                      ),
                    ]
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _vm._m(6),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v("就業状況")]),
              _vm._v(" "),
              _c(
                "td",
                { attrs: { colspan: "2", "data-test": "working-status-name" } },
                [
                  _vm._v(
                    _vm._s(
                      _vm._f("parseBlankForDefaultValue")(
                        _vm.resume.workingStatusName
                      )
                    )
                  ),
                ]
              ),
              _vm._v(" "),
              _c("th", [_vm._v("直近の経験職種")]),
              _vm._v(" "),
              _c(
                "td",
                { attrs: { colspan: "2", "data-test": "recent-job-name" } },
                [
                  _vm._v(
                    _vm._s(
                      _vm._f("parseBlankForDefaultValue")(
                        _vm.resume.recentJobName
                      )
                    )
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _vm.resume.seminarOriginalQuestionAndAnswers
              ? [
                  _vm._m(7),
                  _vm._v(" "),
                  _vm.resume.seminarOriginalQuestionAndAnswers.question1
                    ? [
                        _c(
                          "tr",
                          { attrs: { "data-test": "question-answer-1" } },
                          [
                            _c("th", [_vm._v("質問1")]),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass: "pega-pre-wrap",
                                attrs: { colspan: "5" },
                              },
                              [
                                _c(
                                  "span",
                                  { attrs: { "data-test": "question1" } },
                                  [
                                    _vm._v(
                                      "Q: " +
                                        _vm._s(
                                          _vm.resume
                                            .seminarOriginalQuestionAndAnswers
                                            .question1
                                        )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("br"),
                                _c("br"),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { attrs: { "data-test": "answer1" } },
                                  [
                                    _vm._v(
                                      "A: " +
                                        _vm._s(
                                          _vm._f("parseBlankForDefaultValue")(
                                            _vm.resume
                                              .seminarOriginalQuestionAndAnswers
                                              .answer1
                                          )
                                        )
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.resume.seminarOriginalQuestionAndAnswers.question2
                    ? [
                        _c(
                          "tr",
                          { attrs: { "data-test": "question-answer-2" } },
                          [
                            _c("th", [_vm._v("質問2")]),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass: "pega-pre-wrap",
                                attrs: { colspan: "5" },
                              },
                              [
                                _c(
                                  "span",
                                  { attrs: { "data-test": "question2" } },
                                  [
                                    _vm._v(
                                      "Q: " +
                                        _vm._s(
                                          _vm.resume
                                            .seminarOriginalQuestionAndAnswers
                                            .question2
                                        )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("br"),
                                _c("br"),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { attrs: { "data-test": "answer2" } },
                                  [
                                    _vm._v(
                                      "A: " +
                                        _vm._s(
                                          _vm._f("parseBlankForDefaultValue")(
                                            _vm.resume
                                              .seminarOriginalQuestionAndAnswers
                                              .answer2
                                          )
                                        )
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.resume.seminarOriginalQuestionAndAnswers.question3
                    ? [
                        _c(
                          "tr",
                          { attrs: { "data-test": "question-answer-3" } },
                          [
                            _c("th", [_vm._v("質問3")]),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass: "pega-pre-wrap",
                                attrs: { colspan: "5" },
                              },
                              [
                                _c(
                                  "span",
                                  { attrs: { "data-test": "question3" } },
                                  [
                                    _vm._v(
                                      "Q: " +
                                        _vm._s(
                                          _vm.resume
                                            .seminarOriginalQuestionAndAnswers
                                            .question3
                                        )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("br"),
                                _c("br"),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { attrs: { "data-test": "answer3" } },
                                  [
                                    _vm._v(
                                      "A: " +
                                        _vm._s(
                                          _vm._f("parseBlankForDefaultValue")(
                                            _vm.resume
                                              .seminarOriginalQuestionAndAnswers
                                              .answer3
                                          )
                                        )
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    : _vm._e(),
                ]
              : _vm._e(),
          ],
          2
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "boss-layout boss-layout-gap-between" }, [
      _c(
        "div",
        { staticClass: "boss-resume-sheet-title pega-resume-sheet-title" },
        [_vm._v("履歴書")]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "is-boss-only-pc" }, [
      _c("div", { staticClass: "boss-resume-sheet-photo-space" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "boss-table-4-space", attrs: { colspan: "4" } }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "boss-table-4-space", attrs: { colspan: "6" } }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [_c("th", { attrs: { colspan: "6" } }, [_vm._v("学歴")])])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("th", { attrs: { colspan: "6" } }, [_vm._v("職務経歴（概略）")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "boss-table-4-space", attrs: { colspan: "6" } }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { attrs: { "data-test": "original-question" } }, [
      _c("td", { staticClass: "boss-table-4-space", attrs: { colspan: "6" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }